import styled from "styled-components";
const CreateRequestFormWrapper = styled.div`
  .scroll-spy-link-box .active .spy-box-content {
    border-left-color: #2570fe !important;
  }
`;
export default CreateRequestFormWrapper;
